/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.orchestrator.experiment.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../../validate/validate_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.orchestrator = {};
proto.witbooking.backoffice.orchestrator.experiment = {};
proto.witbooking.backoffice.orchestrator.experiment.v1 = require('./experiment_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse>}
 */
const methodDescriptor_ExperimentAPI_GetExperiment = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/GetExperiment',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse>}
 */
const methodInfo_ExperimentAPI_GetExperiment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.getExperiment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/GetExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_GetExperiment,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.getExperiment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/GetExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_GetExperiment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse>}
 */
const methodDescriptor_ExperimentAPI_GetAllExperiments = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/GetAllExperiments',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse>}
 */
const methodInfo_ExperimentAPI_GetAllExperiments = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.getAllExperiments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/GetAllExperiments',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_GetAllExperiments,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.GetAllExperimentsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.getAllExperiments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/GetAllExperiments',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_GetAllExperiments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse>}
 */
const methodDescriptor_ExperimentAPI_CreateExperiment = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/CreateExperiment',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse>}
 */
const methodInfo_ExperimentAPI_CreateExperiment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.createExperiment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/CreateExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_CreateExperiment,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.CreateExperimentResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.createExperiment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/CreateExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_CreateExperiment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse>}
 */
const methodDescriptor_ExperimentAPI_UpdateExperiment = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/UpdateExperiment',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse>}
 */
const methodInfo_ExperimentAPI_UpdateExperiment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.updateExperiment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/UpdateExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_UpdateExperiment,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.UpdateExperimentResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.updateExperiment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/UpdateExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_UpdateExperiment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse>}
 */
const methodDescriptor_ExperimentAPI_DeleteExperiment = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/DeleteExperiment',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse>}
 */
const methodInfo_ExperimentAPI_DeleteExperiment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.deleteExperiment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/DeleteExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_DeleteExperiment,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.DeleteExperimentResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.deleteExperiment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/DeleteExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_DeleteExperiment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse>}
 */
const methodDescriptor_ExperimentAPI_ReorderExperiment = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ReorderExperiment',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse>}
 */
const methodInfo_ExperimentAPI_ReorderExperiment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.reorderExperiment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ReorderExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_ReorderExperiment,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.ReorderExperimentResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.reorderExperiment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ReorderExperiment',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_ReorderExperiment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse>}
 */
const methodDescriptor_ExperimentAPI_ListExperiments = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ListExperiments',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse>}
 */
const methodInfo_ExperimentAPI_ListExperiments = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.listExperiments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ListExperiments',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_ListExperiments,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.ListExperimentsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.listExperiments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ListExperiments',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_ListExperiments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse>}
 */
const methodDescriptor_ExperimentAPI_ChangeExperimentStatus = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ChangeExperimentStatus',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse>}
 */
const methodInfo_ExperimentAPI_ChangeExperimentStatus = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.changeExperimentStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ChangeExperimentStatus',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_ChangeExperimentStatus,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.ChangeExperimentStatusResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.changeExperimentStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ChangeExperimentStatus',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_ChangeExperimentStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse>}
 */
const methodDescriptor_ExperimentAPI_GetExperimentResults = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/GetExperimentResults',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse>}
 */
const methodInfo_ExperimentAPI_GetExperimentResults = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.getExperimentResults =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/GetExperimentResults',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_GetExperimentResults,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.GetExperimentResultsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.getExperimentResults =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/GetExperimentResults',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_GetExperimentResults);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse>}
 */
const methodDescriptor_ExperimentAPI_ExportExperimentMetrics = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ExportExperimentMetrics',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest,
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest,
 *   !proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse>}
 */
const methodInfo_ExperimentAPI_ExportExperimentMetrics = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse,
  /**
   * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIClient.prototype.exportExperimentMetrics =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ExportExperimentMetrics',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_ExportExperimentMetrics,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.orchestrator.experiment.v1.ExportExperimentMetricsResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPIPromiseClient.prototype.exportExperimentMetrics =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.orchestrator.experiment.v1.ExperimentAPI/ExportExperimentMetrics',
      request,
      metadata || {},
      methodDescriptor_ExperimentAPI_ExportExperimentMetrics);
};


module.exports = proto.witbooking.backoffice.orchestrator.experiment.v1;

